<template>
<div class="product-quantity-controls-component quantity-controls product-modifier-controls in-cart">
  <div class="product-quantity-controls-wrapper">
    <div class="product-quantity-control-column product-quantity-minus">
      <button type="button" class="btn btn-block btn-xs" @click="decrease">
        <i class="fal fa-minus"></i>
      </button>
    </div>
    <div class="product-quantity-control-column product-quantity-number-wrapper">
      <input type="text" tabindex="-1" :value="value" readonly class="text-sm">
    </div>
    <div class="product-quantity-control-column product-quantity-plus">
      <button type="button" class="btn btn-block btn-xs" @click="increase" :disabled="limitReached">
        <i class="fal fa-plus"></i>
      </button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Number,
    },

    minQuantity: {
      required: true,
      type: Number,
    },

    maxQuantity: {
      required: true,
      type: Number,
    },

    limitReached: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  methods: {
    increase() {
      const value = this.value + 1

      if (value > this.maxQuantity) {
        return
      }

      this.$emit('input', value)
    },

    decrease() {
      const value = this.value - 1

      if (value < this.minQuantity) {
        return
      }

      this.$emit('input', value)
    },
  },
}
</script>
